module.exports = __webpack_public_path__ + "img/img3.1b5d31f5.png";